/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { ResponseOf } from './core/schema.utils.d.ts'

import { Preferences } from '@/ts/entities/preferences.ts'
import { User } from '@/ts/entities/user.ts'
import { get } from './core/http.ts'

export type APIHelloData = ResponseOf<'v1/hello', 'get', 200>

export async function getHello() {
  const data = await get<APIHelloData>('/api/v1/hello')

  return {
    whoami: data.whoami && User.fromJSON(data.whoami),
    preferences: Preferences.fromJSON(null), // TODO
    configuration: data.configuration,
  }
}
